export const SearchSubmitButton = () => {
  return (
    <button type='submit' className='btn btn-primary'>
      <i className='ri-search-line align-bottom me-1'></i> Search
    </button>
  );
};
